import { Type, type SchemaOptions } from '@sinclair/typebox';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_PRO_PAYMENT_TYPE = 'PRO_PAYMENT_TYPE_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum ProPaymentType
export enum ProPaymentType {
  BANK_IMPRINT = 'BANK_IMPRINT',
  FULL_PAYMENT = 'FULL_PAYMENT',
  MANUAL_PAYMENT = 'MANUAL_PAYMENT',
  CARD_SAVE = 'CARD_SAVE',
}

export const ProPaymentTypeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_PAYMENT_TYPE}${ProPaymentType.BANK_IMPRINT}`]: 'Empreinte bancaire',
    [`${TRANSLATE_KEY_PRO_PAYMENT_TYPE}${ProPaymentType.FULL_PAYMENT}`]: 'Paiement intégral',
    [`${TRANSLATE_KEY_PRO_PAYMENT_TYPE}${ProPaymentType.MANUAL_PAYMENT}`]: 'Paiement manuel',
    [`${TRANSLATE_KEY_PRO_PAYMENT_TYPE}${ProPaymentType.CARD_SAVE}`]: 'Sauvegarde de CB',
  },
};

validateEnumTranslations(ProPaymentType, ProPaymentTypeTranslation, TRANSLATE_KEY_PRO_PAYMENT_TYPE, true);

export const ProPaymentTypeSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(ProPaymentType).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY_PRO_PAYMENT_TYPE}${value}`,
      }),
    ),
    options,
  );
};

export const TRANSLATE_KEY_PRO_PAYMENT_STATUS = 'PRO_PAYMENT_STATUS_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum ProPaymentStatus
export enum ProPaymentStatus {
  WAITING_PAYMENT = 'WAITING_PAYMENT',
  AUTHORIZED = 'AUTHORIZED',
  PAYED = 'PAYED',
  MANUALLY_PAID = 'MANUALLY_PAID',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  EXPIRED = 'EXPIRED',
}

export const ProPaymentStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_PAYMENT_STATUS}${ProPaymentStatus.WAITING_PAYMENT}`]: 'En attente de paiement',
    [`${TRANSLATE_KEY_PRO_PAYMENT_STATUS}${ProPaymentStatus.AUTHORIZED}`]: 'Empreinte autorisée',
    [`${TRANSLATE_KEY_PRO_PAYMENT_STATUS}${ProPaymentStatus.PAYED}`]: 'Payé',
    [`${TRANSLATE_KEY_PRO_PAYMENT_STATUS}${ProPaymentStatus.MANUALLY_PAID}`]: 'Payé manuellement',
    [`${TRANSLATE_KEY_PRO_PAYMENT_STATUS}${ProPaymentStatus.CANCELLED}`]: 'Annulé',
    [`${TRANSLATE_KEY_PRO_PAYMENT_STATUS}${ProPaymentStatus.REFUNDED}`]: 'Remboursé',
    [`${TRANSLATE_KEY_PRO_PAYMENT_STATUS}${ProPaymentStatus.PARTIALLY_REFUNDED}`]: 'Partiellement remboursé',
    [`${TRANSLATE_KEY_PRO_PAYMENT_STATUS}${ProPaymentStatus.EXPIRED}`]: 'Expiré',
  },
};

validateEnumTranslations(ProPaymentStatus, ProPaymentStatusTranslation, TRANSLATE_KEY_PRO_PAYMENT_STATUS, true);

export const ProPaymentStatusSchema = (options?: SchemaOptions) => {
  return Type.Union(
    Object.values(ProPaymentStatus).map((value) =>
      Type.Literal(value, {
        label: `${TRANSLATE_KEY_PRO_PAYMENT_STATUS}${value}`,
      }),
    ),
    options,
  );
};

export const TRANSLATE_KEY_PRO_PAYMENT_ORIGIN = 'PRO_PAYMENT_ORIGIN_';

/**
 * Origine d'un paiement, DÉDUITE des relations (`reservation` / `voucher`) — il n'existe pas de
 * colonne dédiée en base. Sert au filtre « Origine » de la liste des paiements et au marqueur
 * affiché sur chaque ligne. À ne pas confondre avec `pro_payment.is_created_by_pro`, qui répond à
 * une autre question (qui a créé le paiement) et pilote sa visibilité.
 */
export enum ProPaymentOrigin {
  RESERVATION = 'RESERVATION',
  DIRECT_SALE = 'DIRECT_SALE',
  GIFT_CARD = 'GIFT_CARD',
}

export const ProPaymentOriginTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_PAYMENT_ORIGIN}${ProPaymentOrigin.RESERVATION}`]: 'Réservation',
    [`${TRANSLATE_KEY_PRO_PAYMENT_ORIGIN}${ProPaymentOrigin.DIRECT_SALE}`]: 'Vente directe',
    [`${TRANSLATE_KEY_PRO_PAYMENT_ORIGIN}${ProPaymentOrigin.GIFT_CARD}`]: 'Carte cadeau',
  },
};

validateEnumTranslations(ProPaymentOrigin, ProPaymentOriginTranslation, TRANSLATE_KEY_PRO_PAYMENT_ORIGIN, true);

export const TRANSLATE_KEY_PRO_PAYMENT_EVENT = 'PRO_PAYMENT_EVENT_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum ProPaymentEventType
export enum ProPaymentEventType {
  CREATED = 'CREATED',
  AUTHORIZED = 'AUTHORIZED',
  CAPTURED = 'CAPTURED',
  PAYMENT_RECEIVED = 'PAYMENT_RECEIVED',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  REFUND = 'REFUND',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
  RETRY_CHARGE_ATTEMPTED = 'RETRY_CHARGE_ATTEMPTED',
  RETRY_CHARGE_SUCCESS = 'RETRY_CHARGE_SUCCESS',
  RETRY_CHARGE_FAILED = 'RETRY_CHARGE_FAILED',
  CARD_DETACHED = 'CARD_DETACHED',
  AMOUNT_UPDATED = 'AMOUNT_UPDATED',
  UNLINKED = 'UNLINKED',
  // Lien de paiement envoyé au client (notification PAYMENT_REQUEST). Pas de contact dans `detail` :
  // la colonne part telle quelle dans l'export analytique.
  LINK_SENT_EMAIL = 'LINK_SENT_EMAIL',
  LINK_SENT_SMS = 'LINK_SENT_SMS',
}

export const ProPaymentEventTypeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.CREATED}`]: 'Demande créée',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.AUTHORIZED}`]: 'Empreinte autorisée',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.CAPTURED}`]: 'Paiement encaissé',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.PAYMENT_RECEIVED}`]: 'Paiement reçu',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.CANCELLED}`]: 'Demande annulée',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.EXPIRED}`]: 'Demande expirée',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.REFUND}`]: 'Remboursement effectué',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.REFUND_REQUESTED}`]:
      'Remboursement demandé par le client',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.RETRY_CHARGE_ATTEMPTED}`]: 'Tentative de prélèvement',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.RETRY_CHARGE_SUCCESS}`]: 'Prélèvement réussi',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.RETRY_CHARGE_FAILED}`]: 'Échec du prélèvement',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.CARD_DETACHED}`]: 'Carte détachée',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.AMOUNT_UPDATED}`]: 'Montant mis à jour',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.UNLINKED}`]: 'Détaché du rendez-vous',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.LINK_SENT_EMAIL}`]: 'Lien envoyé par email',
    [`${TRANSLATE_KEY_PRO_PAYMENT_EVENT}${ProPaymentEventType.LINK_SENT_SMS}`]: 'Lien envoyé par SMS',
  },
};

validateEnumTranslations(ProPaymentEventType, ProPaymentEventTypeTranslation, TRANSLATE_KEY_PRO_PAYMENT_EVENT, true);
